import { useState } from 'react';
import Image, { ImageProps } from 'next/image';

const DEFAULT_FALLBACK = '/images/default-poster_1x1.png';

type Props = Omit<ImageProps, 'src'> &
  Omit<
    React.JSX.IntrinsicElements['img'],
    'src' | 'srcSet' | 'ref' | 'alt' | 'width' | 'height' | 'loading'
  > & {
    // Since there is a fallback, src is not required
    src?: ImageProps['src'];
    fallbackSrc?: string;
  };

const ImageWithFallback = ({ fallbackSrc, ...props }: Props) => {
  const fallback = fallbackSrc || DEFAULT_FALLBACK;
  const [src, setSrc] = useState<ImageProps['src']>(props.src || fallback);
  const [prevSrc, setPrevSrc] = useState(props.src);

  if (props.src !== prevSrc) {
    setPrevSrc(props.src);
    setSrc(props.src || fallback);
  }

  return <Image {...props} src={src} alt={props.alt} onError={() => setSrc(fallback)} />;
};

export default ImageWithFallback;
